// commonProperties.js
import { Checkbox } from 'packages';

const CheckBoxR = ({ value, onChange }) =>
  <Checkbox checked={value} onChange={v => onChange(v?.target?.checked)}>Mark as mandatory</Checkbox>;

const commonProperties = [
  {
    key: 'label',
    placeholder: 'Enter Label',
    label: 'Field Title',
    colSpan: 3,
    rules: [{ required: true, message: `Please enter a label to display in the form` }]
  },
  {
    key: 'placeholder',
    placeholder: 'Enter placeholder',
    label: 'Placeholder',
    colSpan: 3
  },

  {
    key: 'required',
    colSpan: 3,
    label: '',
    widget: CheckBoxR,
    initialValues: false
  }
];

export default commonProperties;